import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KIconModule } from 'ng-k-icon';
import { KButtonModule } from 'ng-k-button';
import { KDataVisualizationModule } from 'ng-k-data-visualization';
import { KModalModule } from 'ng-k-modal';
import { KNotificationsModule } from 'ng-k-notifications';
import { KFormModule } from 'ng-k-form';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgChartsModule } from 'ng2-charts';
import { PleuralthickeningRoutingModule } from './pleural-thickening-routing.module';
import { AssessContributionToCostsComponent } from './apportionment/assess-contribution-to-costs/assess-contribution-to-costs.component';
import { ActivityListingComponent } from './exposure/activity-listing/activity-listing.component';
import { OutlineExposureToDustComponent } from './exposure/outline-exposure-to-dust/outline-exposure-to-dust.component';
import { EstablishBreachOfDutyComponent } from './investigation/establish-breach-of-duty/establish-breach-of-duty.component';
import { EstablishCausationComponent } from './investigation/establish-causation/establish-causation.component';
import { RadiologicalProgressionPleuralThickeningComponent } from './radiological-progression-pleural-thickening/radiological-progression-pleural-thickening.component';
import { KCardModule } from 'ng-k-card';
import { RadiologicalProgressionChartPleuralComponent } from './radiological-progression-chart/radiological-progression-chart-pleural.component';
import { AsbestosRadiologicalProgressionChartModule } from '../common/asbestos-radiological-progression-chart/asbestos-radiological-progression-chart.module';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap'; // Import only NgbAccordionModule
import { CustomBreadcrumbModule } from '../common/custom-breadcrumb/custom-breadcrumb.module';

@NgModule({
  declarations: [
    AssessContributionToCostsComponent,
    ActivityListingComponent,
    OutlineExposureToDustComponent,
    EstablishBreachOfDutyComponent,
    EstablishCausationComponent,
    RadiologicalProgressionPleuralThickeningComponent,
    RadiologicalProgressionChartPleuralComponent,
  ],
  imports: [
    CommonModule,
    KButtonModule,
    KIconModule,
    KNotificationsModule,
    KDataVisualizationModule,
    KModalModule,
    KFormModule,
    ReactiveFormsModule,
    FormsModule,
    NgChartsModule,
    PleuralthickeningRoutingModule,
    KCardModule,
    AsbestosRadiologicalProgressionChartModule,
    NgbAccordionModule,
    CustomBreadcrumbModule
  ]
})
export class PleuralthickeningModule { }
